import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "nodes_update",
  "use": "nodes_update-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"nodes_update\"><rect width=\"40\" height=\"40\" rx=\"20\" fill=\"#F9A825\" /><path d=\"M20 10.285c-5.356 0-9.715 4.358-9.715 9.715s4.359 9.715 9.715 9.715 9.715-4.358 9.715-9.715-4.36-9.715-9.715-9.715zm0 4.382a1.334 1.334 0 11-.001 2.668 1.334 1.334 0 010-2.668zm2.666 8.67c0 .918-.744 1.663-1.662 1.663h-3.67v-.281c0-.93.742-1.679 1.666-1.708v-2.344h-1.667a2 2 0 012-2H21V23h1.666v.337z\" fill=\"#FFF8E1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol